import { FC } from "react";
import { Box, Theme } from "@mui/material";
import { Formik, FormikHelpers } from "formik";
import { Modal, ModalProps } from "@vilocnv/allsetra-core";
import {
  reportsWorkingHoursFormInitialValues,
  reportsWorkingHoursFormValidationSchema
} from "app/data/helpers";
import { getResetFilterFormValues } from "app/data/helpers/ReportHelpers";
import InnerForm from "./children/InnerForm";
import { useTranslation } from "react-i18next";

export type WorkingHoursFilterFormProps = Pick<
  ModalProps,
  "open" | "onClose"
> & {
  onSubmit: (values: any, formikHelpers: FormikHelpers<any>) => void;
  theme: Theme;
  dataLoading?: boolean;
  groups: Array<any>;
  objectTypes: Array<any>;
  objects: Array<any>;
  keys: Array<any>;
  submitting?: boolean;
  fetchOnDebounce: (value: string) => void;
  onChange?: (val?: any) => void;
  formInitialValues?: Record<string, any>;
  onResetFilters?: () => void;
};

const WorkingHoursFilterForm: FC<WorkingHoursFilterFormProps> = ({
  open,
  onClose,
  onSubmit,
  theme,
  dataLoading = false,
  groups,
  objects,
  objectTypes,
  keys,
  submitting = false,
  fetchOnDebounce,
  onChange,
  formInitialValues = reportsWorkingHoursFormInitialValues,
  onResetFilters
}) => {
  const { t } = useTranslation(["translation", "formFieldsTranslation"]);

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={reportsWorkingHoursFormValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnMount
    >
      {({
        handleSubmit,
        isSubmitting,
        isValid,
        values,
        setFieldValue,
        resetForm
      }) => (
        <Modal
          open={open}
          onClose={() => {
            onClose();
          }}
          title="Filters"
          primaryBtnProps={{
            type: "submit",
            text: t("buttonsText.apply"),
            loading: isSubmitting || submitting,
            // @ts-ignore
            onClick: handleSubmit,
            disabled: !isValid
          }}
          secondaryBtnProps={{
            text: t("buttonsText.cancel"),
            onClick: onClose
          }}
          theme={theme}
          size="customSize"
        >
          <>
            <InnerForm
              groups={groups}
              objectTypes={objectTypes}
              objects={objects}
              keys={keys}
              dataLoading={dataLoading}
              translator={t}
              fetchOnDebounce={fetchOnDebounce}
              onChange={onChange}
              values={values}
              setFieldValue={setFieldValue}
            />
            <Box mt={2} display="flex" justifyContent="flex-start">
              <button
                type="button"
                onClick={() => {
                  const resetValues = getResetFilterFormValues(
                    formInitialValues as Record<string, any>
                  );
                  resetForm({ values: resetValues });
                  onChange?.([]);
                  onResetFilters?.();
                  fetchOnDebounce("");
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: theme.palette.primary.main,
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontSize: 14,
                  padding: 0
                }}
              >
                {t("buttonsText.reset", { defaultValue: "Reset filters" })}
              </button>
            </Box>
          </>
        </Modal>
      )}
    </Formik>
  );
};

export default WorkingHoursFilterForm;
